import { defineComponent as a, computed as o, openBlock as c, createElementBlock as i, createElementVNode as e, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], u = /* @__PURE__ */ e("mask", { id: "9770e137-c19c-40b2-9fc9-9b7750a774e2" }, [
  /* @__PURE__ */ e("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), m = { mask: "url(#9770e137-c19c-40b2-9fc9-9b7750a774e2)" }, k = { key: 0 }, p = /* @__PURE__ */ e("path", {
  fill: "#d80027",
  d: "m0 167 253.8-19.3L512 167v178l-254.9 32.3L0 345z"
}, null, -1), v = /* @__PURE__ */ e("path", {
  fill: "#eee",
  d: "M0 0h512v167H0z"
}, null, -1), g = /* @__PURE__ */ e("path", {
  fill: "#ffda44",
  d: "M0 345h512v167H0z"
}, null, -1), x = { fill: "none" }, w = ["r"], B = /* @__PURE__ */ a({
  __name: "south_ossetia",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(r) {
    const t = r, l = o(() => 512 + 2 * t.strokeWidth), s = o(() => -t.strokeWidth), n = o(() => 256 + t.strokeWidth / 2);
    return (y, W) => (c(), i("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      u,
      e("g", m, [
        t.flagName ? (c(), i("title", k, d(t.flagName), 1)) : _("", !0),
        p,
        v,
        g
      ]),
      e("g", x, [
        e("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: t.strokeColor, strokeWidth: t.strokeWidth })
        }, null, 12, w)
      ])
    ], 8, h));
  }
});
export {
  B as default
};
//# sourceMappingURL=south_ossetia-8a0b5ab1.js.map
